import { Grid, Box, Typography } from '@mui/material';
import React from 'react';
import Carousel from 'react-material-ui-carousel';
import {
  docenteEstudiantes,
  docenteFeliz,
  estudianteApp,
  estudianteDeporte,
  estudianteFeliz,
  estudianteTrabajo,
  grupoDocentes,
} from '../../../helpers/ImagesUtils';
import { BLUE_COLOR, PURPLE_COLOR } from '../../../constants/ColorsConst';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CarruselIntroComponent = ({ onChange }) => {
  var items = [
    {
      name: 'Mejora de la Comunicación y la Transparencia',
      descriptions: [
        'Brindamos una plataforma centralizada donde los docentes, estudiantes y padres pueden acceder de manera rápida y sencilla a la información académica. Esto promueve una comunicación fluida y transparente entre todas las partes interesadas, lo que permite a los padres estar al tanto del progreso de sus hijos y a los docentes compartir retroalimentación y actualizaciones con mayor eficiencia.',
      ],
      img: docenteEstudiantes,
    },
    {
      name: 'Personalización del Aprendizaje',
      descriptions: [
        'Los programas suelen ser más específicos y orientados a habilidades, la personalización del aprendizaje es crucial.',
        'Permitimos a los docentes rastrear el rendimiento de cada estudiante en áreas técnicas específicas y adaptar su enfoque pedagógico según las necesidades individuales.Esto asegura que los estudiantes reciban la atención y el apoyo necesarios para tener éxito en su educación técnica.',
      ],
      img: docenteFeliz,
    },
    {
      name: 'Identificación Temprana de Dificultades',
      descriptions: [
        'Una de las ventajas clave de On EDU es su capacidad para detectar patrones de bajo rendimiento o dificultades de aprendizaje en etapas tempranas. Los docentes pueden utilizar los datos recopilados para identificar a los estudiantes que puedan necesitar intervenciones adicionales y ofrecerles el apoyo necesario antes de que las dificultades se vuelvan insuperables.',
      ],
      img: estudianteApp,
    },
    {
      name: 'Seguimiento de Proyectos y Logros Técnicos',
      descriptions: [
        'Los proyectos y las habilidades prácticas desempeñan un papel fundamental.',
        'On EDU permitir a los estudiantes registrar y rastrear sus proyectos, competencias y logros técnicos a lo largo del tiempo. Esto no solo brinda a los estudiantes una evidencia tangible de su progreso, sino que también facilita la evaluación de su desarrollo de habilidades técnicas.',
      ],
      img: estudianteFeliz,
    },
    {
      name: 'Preparación para el Mundo Laboral',
      descriptions: [
        'Una educación exitosa debe preparar a los estudiantes para el mundo laboral.',
        'Podemos ayudar a los estudiantes a desarrollar habilidades de gestión del tiempo, seguimiento de tareas y autodirección, habilidades que son valiosas en cualquier entorno profesional.',
      ],
      img: estudianteTrabajo,
    },
    {
      name: 'Evaluación y Mejora del Plan de Estudios',
      descriptions: [
        'Proporcionamos una fuente valiosa de datos que los educadores pueden utilizar para evaluar la efectividad de su plan de estudios. Al analizar el rendimiento de los estudiantes en diferentes áreas, los docentes pueden identificar fortalezas y debilidades del programa y realizar ajustes para mejorar la calidad de la educación ofrecida.',
      ],
      img: grupoDocentes,
    },
    {
      name: 'Actívate al máximo',
      descriptions: [
        'On EDU es una aplicación que te ayuda a progresar tanto en el deporte como en los estudios. Registra tu actividad física para obtener insignias y recompensas. Los usuarios activos tienen hasta un 8% más de promedio escolar, ya que el ejercicio mejora la concentración y el desempeño académico. La app promueve la competencia amistosa entre estudiantes y entiende que el equilibrio entre el estudio y la actividad física es clave para el éxito.',
        'Impulsamos tu salud y tus logros escolares.',
      ],
      img: estudianteDeporte,
    },
  ];

  return (
    <Carousel
      autoPlay={false}
      navButtonsAlwaysVisible
      NextIcon={<ArrowForwardIcon />}
      PrevIcon={<ArrowBackIcon />}
      animation={'slide'}
      swipe={true}
      indicatorIconButtonProps={{
        style: {
          padding: '7px', // 1
          color: PURPLE_COLOR, // 3
          marginRigth: '10px',
        },
      }}
      activeIndicatorIconButtonProps={{
        style: {
          border: `${PURPLE_COLOR} 4px solid `,
        },
      }}
      indicatorContainerProps={{
        style: {
          marginTop: '5px', // 5
          textAlign: 'center', // 4
        },
      }}
      onChange={onChange}
    >
      {items.map((item, i) => (
        <Item key={i} item={item} />
      ))}
    </Carousel>
  );
};

function Item({ item }) {
  return (
    <Box sx={{ height: '432px', px: '80px' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Typography
            align="left"
            sx={{
              fontSize: '30pt',
              color: BLUE_COLOR,
              fontWeight: 'bold',
              my: 3,
              lineHeight: 1,
            }}
          >
            {item.name}
          </Typography>
          {item.descriptions.map((descriptor) => (
            <Typography sx={{ fontSize: '14pt', mt: 2, textAlign: 'justify' }}>
              {descriptor}
            </Typography>
          ))}
        </Grid>
        <Grid item xs={12} md={6} align="center">
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              height: 'auto',
              color: 'red',
              backgroundColor: BLUE_COLOR,
              boxShadow: `15px 15px 25px -10px ${BLUE_COLOR}`,
              borderRadius: '40px',
            }}
          >
            <img
              src={item.img}
              alt={item.name}
              style={{
                width: '100%',
                borderRadius: '40px',
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CarruselIntroComponent;
